module.exports = __webpack_public_path__ + "img/small-15.6dbf2958.jpg";